import Mutations from '../../odata/mutations';

export default { ...new Mutations('agreementDefault'), ...new Mutations('agreementDefaults') };
